import type { ExposeInterface } from './types';

export const useParentControlStore = defineStore('ParentControl', (): ExposeInterface => {
    const adultControl: Ref<{
        isModalParentVisible: boolean;
        isAdultPinCorrect: boolean;
        targetWidget: string | null;
    }> = ref({
        isModalParentVisible: false,
        isAdultPinCorrect: false,
        /**
         * The name of the widget that will intercept the "correct adult password" event
         */
        targetWidget: null,
    });

    const getIsModalParentVisible = computed((): boolean => adultControl.value.isModalParentVisible);
    const getTargetWidgetAdultControl = computed((): string | null => adultControl.value.targetWidget);
    const getIsAdultPinCorrect = computed((): boolean => adultControl.value.isAdultPinCorrect);

    const ShowParentModal = (): void => {
        adultControl.value.isModalParentVisible = true;
    };

    const HideParentModal = (): void => {
        adultControl.value.isModalParentVisible = false;
    };

    const SetCorrectAdultPin = (): void => {
        adultControl.value.isAdultPinCorrect = true;
    };

    const SetIncorrectAdultPin = (): void => {
        adultControl.value.isAdultPinCorrect = false;
    };

    const SetTargetWidgetAdultControl = (widgetName: string | null): void => {
        adultControl.value.targetWidget = widgetName;
    };

    const ClearTargetWidgetAdultControl = (): void => {
        adultControl.value.targetWidget = null;
    };

    const setToInitialState = (): void => {
        adultControl.value.isModalParentVisible = false;
        adultControl.value.isAdultPinCorrect = false;
        adultControl.value.targetWidget = null;
    };

    return {
        getIsModalParentVisible,
        getTargetWidgetAdultControl,
        getIsAdultPinCorrect,
        ShowParentModal,
        HideParentModal,
        SetCorrectAdultPin,
        SetIncorrectAdultPin,
        SetTargetWidgetAdultControl,
        ClearTargetWidgetAdultControl,
        setToInitialState,
    };
});